import axios from "axios";
import axiosApi from "./axios.service";

const API_URL = process.env.REACT_APP_API_URL;

const headers = {
  "Content-Type": "application/json;charset=UTF-8",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  Accept: "application/json",
};

// 📌 Login
export const login = async (usuario, password) => {
  return axios
    .post(
      `${API_URL}auth/login`,
      { email: usuario, password: password },
      { headers }
    )
    .then((response) => {
      if (response.data.token) {
        localStorage.setItem("userData", JSON.stringify(response.data));
        localStorage.setItem("usuario", response.data.nombre);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("rol", response.data.rol);
        localStorage.setItem("status", response.data.status);
        localStorage.setItem("id_empresa", response.data.id_empresa);
      } else {
        throw new Error("El usuario no tiene permiso para acceder al panel");
      }

      return response.data;
    });
};

// 📌 Logout
export const logout = () => {
  localStorage.clear();
};

export const impersonate = async (userId) => {
  try {
    console.log(`🔑 Intentando impersonar usuario con ID: ${userId}`);

    const response = await axiosApi.post(`revendedor/autologin/${userId}`);

    console.log("📌 Respuesta completa de la API:", response);

    if (response.data.token) {
      console.log("✅ Token de impersonación recibido:", response.data.token);
      return response.data; // 📌 Ahora realmente devuelve los datos
    } else {
      throw new Error("No se recibió un token válido en la respuesta.");
    }
  } catch (error) {
    console.error("❌ Error durante la suplantación de usuario:", error);
    throw error;
  }
};
// funciones varias
export const generateAlphanumericString = async (length) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};
export const validateCIF = (cif) => {
  const cifRegex = /^[A-HJ-NP-SUVW][0-9]{7}[0-9A-J]$/i;
  return cifRegex.test(cif);
};
export const validateNIF = (nif) => {
  const nifRegex = /^[0-9]{8}[A-Z]$/i;
  if (!nifRegex.test(nif)) return false;

  const number = nif.slice(0, 8);
  const letter = nif.slice(8).toUpperCase();
  const validLetter = "TRWAGMYFPDXBNJZSQVHLCKE"[number % 23];

  return letter === validLetter;
};

export const validateNIE = (nie) => {
  const nieRegex = /^[XYZ][0-9]{7}[A-Z]$/i;
  if (!nieRegex.test(nie)) return false;

  const prefix = { X: 0, Y: 1, Z: 2 }[nie[0]];
  const number = `${prefix}${nie.slice(1, 8)}`;
  const letter = nie.slice(8).toUpperCase();
  const validLetter = "TRWAGMYFPDXBNJZSQVHLCKE"[number % 23];

  return letter === validLetter;
};
export const validatePhone = (phone) => {
  const phoneRegex = /^[0-9]{9}$/;
  return phoneRegex.test(phone);
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
// Servicio para enviar los datos del formulario
export const crearEmpresa = async (formData) => {
  console.log("crearEmpresa", formData);
  try {
    const response = await axiosApi.post(`${API_URL}revendedor/clientes`, {
      nombre: formData.nombreEmpresa,
      nombreFiscal: formData.nombreFiscal,
      cif: formData.cif,
      direccion: formData.direccion,
      cp: formData.codigoPostal,
      localidad: formData.localidad,
      provincia: formData.provincia,
      personaContacto: formData.personaContacto,
      telefono: formData.telefono,
      email: formData.email,
      crearcuentaPanel: formData.crearcuentaPanel,
    });
    return response.data;
  } catch (error) {
    console.error("Error al enviar la solicitud:", error);
    throw error.response?.data || "Error desconocido al enviar la demo";
  }
};
